import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { logLibraryEvent } from "./libraryAnalytics";

/**
 * Repository callable insight (Sesi L11, pola reportStore).
 * Simpan/terapkan dari poin brief terbit saja (keputusan founder B);
 * verifikasi pointId dilakukan server terhadap brief terpublikasi.
 */
export function validateInsightText(text) {
  const t = typeof text === "string" ? text.trim() : "";
  if (t.length < 3 || t.length > 280) return { error: "invalid" };
  return { text: t };
}

export async function saveInsight({ bookId, sourceId, text, briefVersion, pointId, note }) {
  const valid = validateInsightText(text);
  if (valid.error) return { error: "invalid" };
  if (!bookId || !pointId) return { error: "invalid" };
  try {
    const fn = httpsCallable(functions, "saveSourceInsight");
    const payload = { bookId, text: valid.text, pointId };
    if (sourceId) payload.sourceId = sourceId;
    if (briefVersion != null) payload.briefVersion = briefVersion;
    if (typeof note === "string" && note.trim().length > 0) {
      payload.note = note.trim().slice(0, 280);
    }
    const res = await fn(payload);
    if (res.data?.ok && res.data.insightId) {
      void logLibraryEvent("knowledge_saved", { hasNote: Boolean(payload.note) });
      return { insightId: res.data.insightId };
    }
    return { error: "write" };
  } catch (err) {
    if (err?.code === "functions/invalid-argument") return { error: "invalid" };
    if (err?.code === "functions/not-found") return { error: "missing" };
    return { error: "write" };
  }
}

export async function listInsights() {
  try {
    const fn = httpsCallable(functions, "listSourceInsights");
    const res = await fn({});
    if (res.data?.ok && Array.isArray(res.data.insights)) {
      return { insights: res.data.insights };
    }
    return { error: "read" };
  } catch {
    return { error: "read" };
  }
}

export async function applyInsight({ insightId, bookId, sourceId, text, briefVersion, pointId, decisionId }) {
  if (!decisionId) return { error: "invalid" };
  try {
    const fn = httpsCallable(functions, "applySourceInsight");
    const payload = { decisionId };
    if (insightId) {
      payload.insightId = insightId;
    } else {
      const valid = validateInsightText(text);
      if (valid.error || !bookId || !pointId) return { error: "invalid" };
      payload.text = valid.text;
      payload.bookId = bookId;
      payload.pointId = pointId;
      if (sourceId) payload.sourceId = sourceId;
      if (briefVersion != null) payload.briefVersion = briefVersion;
    }
    const res = await fn(payload);
    if (res.data?.ok && res.data.itemId) {
      void logLibraryEvent("apply_to_decision", { hasSourceRef: true });
      return { itemId: res.data.itemId, decisionId: res.data.decisionId };
    }
    return { error: "write" };
  } catch (err) {
    if (err?.code === "functions/invalid-argument") return { error: "invalid" };
    if (err?.code === "functions/not-found") return { error: "missing" };
    if (err?.code === "functions/permission-denied") return { error: "locked" };
    if (err?.code === "functions/failed-precondition") return { error: "unavailable" };
    return { error: "write" };
  }
}

export async function deleteInsight(insightId) {
  if (!insightId) return { error: "invalid" };
  try {
    const fn = httpsCallable(functions, "deleteSourceInsight");
    const res = await fn({ insightId });
    if (res.data?.ok) return { ok: true };
    return { error: "write" };
  } catch (err) {
    if (err?.code === "functions/not-found") return { error: "missing" };
    return { error: "write" };
  }
}
